import { useTranslation } from "react-i18next";
import React from "react";
import { Footer } from "../../layout/Footer/Footer";
import "./ErrorTenant.scss";

type Props = {
  clientName: string;
};

export const ErrorTenant: React.FC<Props> = (props: Props) => {
  const { t, i18n } = useTranslation("common");

  return (
    <div className="exception-body error p-2">
      <div className="exception-wrapper">
        <div className="exception-content">
          <img
            src="assets/layout/images/pages/asset-error.svg"
            alt="Error"
            loading="lazy"
          />
          <span>
            {t("NewCart_TenantDoesNotExist", { ClientName: props.clientName })}
          </span>
        </div>
        <Footer />
      </div>
    </div>
  );
};
